declare let Fancybox: any;

export function initFancybox() {
  Fancybox.bind('[data-fancyrefe]', {
    Thumbs: {
      autoStart: false,
    },
  });
}
